<template>
  <div id="login" :style="{transformOrigin: 'top left',height: '100vh',width: '100vw'}">
    <div class="loginConbox">
      <div class="login-content" :style="scaleStyle">
        <div class="right-content">
          <div class="titleModify">
            密码修改
          </div>
          <el-form
              :model="loginForm"
              :rules="rules"
              label-width="0"
              class="demo-ruleForm"
              ref="modifyForm"
              hide-required-asterisk
            >
              <el-form-item prop="oldPassword">
                <el-input
                  type="password"
                  v-model="loginForm.oldPassword"
                  ref="pwd"
                  auto-complete="off"
                  placeholder="输入旧密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="newPassword">
                <el-input
                  type="password"
                  v-model="loginForm.newPassword"
                  ref="pwd"
                  auto-complete="off"
                  placeholder="输入新密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="confirmPassword">
                <el-input
                  type="password"
                  v-model="loginForm.confirmPassword"
                  ref="pwd"
                  auto-complete="off"
                  placeholder="确认新密码"
                  show-password
                >
                </el-input>
              </el-form-item>
                <el-button
                style="margin-top: 15px"
                class="login-subBtn"
                type="primary"
                @click="submitForm"
                >修改并登录
                </el-button>

            </el-form>
        </div>
      </div>
      <!-- <div class="login-footer">
      <span>@2010-2022 长沙汉森办公科技有限公司版权所有</span><a style="margin-left:10px" href="https://beian.miit.gov.cn/">湘ICP备13005457号-3</a><img src="../../assets/ba.png" style="width: 16px;"><a href="https://beian.mps.gov.cn/#/query/webSearch?code=43010402001514" rel="noreferrer" target="_blank">湘公网安备43010402001514</a>
      </div> -->
    </div>
  </div>
</template>
<script>
import { encryptDes } from '@/utils/des'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      smdl: true,
      checked: true,
      loginForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      options: [],
      companyName: false,
      scaleStyle: {
				transform: 'scale(1)',
			},
      rules: {
        oldPassword: [{required: true, message: '请输入原登录密码'}],
        newPassword: [{required: true, message: '请输入新密码'},{
          validator: (rule, value, callback) => {
            // let pwdRegex  = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,}$/ 
            // if (!pwdRegex.test(value)) {
            //   callback(new Error('密码中必须包含字母、数字、特殊字符，且不少于8位'))
            // }
            if (value.length < 6) {
              callback(new Error('密码长度不能少于6位'))
            }
            callback()
          }
        }],
        confirmPassword: [{required: true, message: '请输入确认新密码'}, {
          validator: (rule, value, callback) => {
            if (value !== this.loginForm.newPassword) {
              callback(new Error('密码输入不一致'))
            }
            callback()
          }
        }]
      }
    }
  },
  methods: {
    setCookies(name,pwd,aspName){
      Cookies.set('name', name, { expires: 365 })
      Cookies.set('pwd', pwd, { expires: 365 })
      Cookies.set('aspName', aspName, { expires: 365 })
    },
    submitForm () {
      this.$refs.modifyForm.validate(valid => {
        if (valid) {
          // 调用方法登录后台
          this.$axios({
            method: 'post',
            url: this.global.DMZ_BASE + '/forceUpdateUserPassword', // 这里是发送给后台的数据'/base/acl/staff/login'
            data: {
              data: {
                ...this.$route.params,
                oldPassword: encryptDes(this.loginForm.oldPassword),
                newPassword: encryptDes(this.loginForm.newPassword),
                userType: 'staff'
              }
            }
          })
            .then((response) => {
              // 这里使用了ES6的语法
              if (response.data.status === 'Y') {
                this.setCookies(encryptDes(this.$route.params.loginName), encryptDes(this.loginForm.newPassword), encryptDes(this.$route.params.aspName))
                this.$router.push('/login')
              }
            })
            .catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
        } else {
          return false
        }
      })
    },
    message () {
      const h = this.$createElement
      this.$notify({
        title: '警告',
        message: h('i', { style: 'color: teal' }, ''),
        duration: 6000
      })
    },
    updateScale() {
			const designWidth = 380;
			const designHeight = 260; // 设计稿基准高度
			const windowWidth = window.innerWidth;
			const windowHeight = window.innerHeight;

			// 动态调整容器高度（避免留白）
      const containerWidth = 380 / 1920 * windowWidth
			const containerHeight = 260 / 1030 * windowHeight;

      const scale = containerWidth / 380

      console.log(containerWidth,'scale',containerHeight)

			this.scaleStyle = {
        transformOrigin: 'top left',
				transform: `scale(${scale})`,
			}
		},
  },
  created () {
    console.log(this.$route.query.params);
    
  },
  mounted() {
		this.updateScale();
		window.addEventListener('resize', this.updateScale);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateScale);
	},
}
</script>
<style lang="scss" scoped>
#login {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  background: url(../../assets/images/blue-sky-background.jpg) no-repeat;
  background-size: 100% 100%;
  position: relative;
  // .logo {
  //   margin-bottom: 40px;
  //   text-align: center;
  // }
  // .logo img {
  //   width: 80%;
  // }

  .loginConbox {
    margin: 0 auto;

    .logo {
      font-family: AdobeHeitiStd-Regular;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      /* color: #2361ff; */
    }

    .login-content {
      box-shadow: 0 5px 20px 0 rgba(89,82,82,0.3);
      border-radius: 12px;
      // overflow: hidden;
      width: 380px;
      max-height: 350px;
      position: absolute;
      top:25%;
      left: 40%;
      transform: translate(-50%,-50%);
      background-color: #fff;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 15px 30px 15px;
      transition: all .1s linear;
    }

    .login-footer{
      position: absolute;
      width: 100%;
      bottom: 20px;
      left:0;
      line-height: 20px;
      font-size: 16px;
      color: #fff;
      text-align: center;
    }

    .logo-left {
      // flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;

      .login-logo {
        margin-top: 50px;
        text-align: center;

        img{
          width: 65%;
        }
      }

      .logo-content {
        position: absolute;
        left: 25px;
        bottom: 27px;

        .top {
          margin: 0;
          font-family: FZLTHK--GBK1-0;
          font-size: 26px;
          font-weight: bold;
          font-stretch: normal;
          // line-height: 1px;
          letter-spacing: 0px;
          color: #f7f9ff;
        }

        .bottom {
          font-family: FZLTHK--GBK1-0;
          font-size: 10px;
          font-weight: normal;
          letter-spacing: 0px;
          color: #f7f9ff;
        }
      }
    }

    .right-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      width: 100%;
      background-color: #fff;
      top:15%;

      .logo {
        text-align: center;

        img {
          width: 80px;
        }
      }

      .titleModify {
        margin-top:10px;
        position: relative;
/*         font-family: MicrosoftYaHei-Bold; */
        font-size: 24px;
        text-align: center;
        font-weight: 600;
        font-stretch: normal;
        letter-spacing:0px;
        color: #c7180c; // #70BAFD
        background: #fff;
      }

      // .title::after {
      //   content: "";
      //   position: absolute;
      //   left: 0;
      //   bottom: -9px;
      //   width: 40px;
      //   height: 2px;
      //   background-color: #2265fe;
      // }

      .el-form {
        margin-top: 30px;
        text-align: center;

        .el-input__prefix {
          top: 8px !important;

          img {
            width: 18px;
          }
        }

        .el-input__suffix .el-input__icon {
          line-height: 1 !important;
        }

        .el-form-item__content {
          /* border: none !important; */
          line-height: 0 !important;
        }

        .el-form-item {
          margin-bottom: 15px !important;
        }

        .login-subBtn {
          margin-top: 30px;
          height:40px;
          font-size:16px;
          border: none;
          /* box-shadow: 4px -6px 20px 1px rgba(28, 156, 255, 0.17); */
          background-color:#c7180c;
        }

        .operation .el-form-item__content{
          display: flex;
          align-items: center;
          justify-content: space-between;
          border:none !important;
          color:#565e66;

          a {
            font-family: MicrosoftYaHei;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 35px;
            letter-spacing: 0px;
            color: #565e66;
          }

          a:hover{
            text-decoration:none;
          }
        }
      }

      .el-input,
      button,
      input {
        width: 100%;
        height: 34px;

      }

      .tip {
        position: absolute;
        bottom: 12px;
        width: 100%;
        text-align: center;
        font-family: ArialMT;
        font-size: 9px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #b3cdff;
      }
    }
  }

  .login-subBtn:hover {
    background-color: #005ea6;
  }
  .el-input__inner:focus {
    border-bottom: 1px solid #b40005;
    border-radius:0px;
  }
  .el-select {
    width: 100%;
  }

  .loginBox {
    .iconcolor {
      color: #409eff;
    }

    .loginCon {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 990px;
      margin: auto;

      .el-card__header {
        border-bottom: 0px;
      }
      .title {
        font-size: 30px;
        font-weight: 600;
        color: #ffffff;
        width: 500px;
        margin-top: 0px;
        text-align: center;

        &:first-child {
          font-size: 30px;
          margin-top: 50px;
          // margin-bottom: 30px;
        }
      }

      .login-module {
        width: 380px;
        height: 380px;
        border: none;
        margin-top: 30px;

        .formTitlt {
          font-size: 18px;
          font-weight: 400;

          .titIconbox {
            float: right;

            .pointer {
              cursor: pointer;
            }
          }
        }

        .smalltxt {
          text-align: right;

          .a {
            text-decoration: none;
            color: #999999;
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }

      .el-form-item__content {
        margin-left: 0px !important;

        .subBtn {
          width: 100%;
        }
      }
    }

    .el-input__inner,
    .el-button,
    .el-card,
    .el-message {
      border-radius: 5px !important;
    }

    .el-form-item__content .ico {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 999;
      width: 40px;
      height: 39px;
      text-align: center;
      border-right: 1px solid #ccc;
    }

    .ewmbox {
      width: 100%;
      height: 240px;
      margin-top: -25px;

      .ewm {
        width: 140px;
        height: 140px;
        margin: 20px auto;

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }

      .ewmicon {
        width: 140px;
        margin: 20px auto 0;

        .iconfont {
          float: left;
        }

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }
    }
  }

  /* login样式修改 */

  .el-card {
    margin: 120px auto 0;
    padding: 42px 42px 36px;
    border: 1px solid #eaeced;
    overflow: hidden;
  }

  .el-card__body {
    padding: 20px 40px;

    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form-item__content {
      line-height: 35px;
    }

    .el-input__inner {
      height: 34px;
      line-height: 34px;
      border:0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/modifyPassword.vue